import React from 'react'
import { Button } from '@driftt/dds'
import { Div, NavigationHeader } from '@driftt/tide-core'
import CSVImportLogs from './CSVImportLogs'

import './style.css'

const ImportLogs = props => {
  const { history } = props

  return (
    <Div className="import-logs--wrapper">
      <NavigationHeader title="Import accounts">
        <Button onClick={() => history.push('/imports/new')}>New import</Button>
      </NavigationHeader>
      <CSVImportLogs/>
    </Div>
  )
}

export default ImportLogs
